<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
				
		 <b-col class="p-0">
			<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> -->
			
		
			<b-container fluid>
				<b-row>
					<b-col class="col-md-12 col-sm-12 col-xs-12">
						<div class="container-box">
							<b-row class="mt-4 px-3">
								<b-col lg="2" class="text-left">
									<span class="mr-2">Date From</span>
									<b-form-datepicker id="datepicker-from" v-model="datefrom" class="mb-2" placeholder="No date"></b-form-datepicker>
								</b-col>
								<b-col lg="2" class="text-left">
									<span class="mr-2">Date To</span>
									<b-form-datepicker id="datepicker-to" v-model="dateto" class="mb-2" placeholder="No date"></b-form-datepicker>
								</b-col>
								<b-col lg="2" class="text-left">
									<span class="mr-2">Status</span>
									<b-form-select v-model="order_status" required>
										<b-form-select-option value="">All</b-form-select-option>
										<b-form-select-option v-for="item in $root.order_status" :key="item.slug" :value="item.slug">{{item.label}}</b-form-select-option>
									</b-form-select>
								</b-col>
								<b-col lg="2" class="text-left">
									<b-button pill variant="primary" class="mt-4" @click="loadData()" size="sm">Submit</b-button>
								</b-col>
								
								<b-col lg="2" offset-md="2">
									<span class="mr-2">Status</span>
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-col>
							</b-row>
							<b-row class="px-3 pt-3">
								<b-col lg="12">
									<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
										<template v-slot:cell(status)="row">
											<b-badge pill variant="warning" v-if="row.value == 0">NEW</b-badge>
											<b-badge pill variant="success" v-else>IN PROCESS</b-badge>
										</template>
										<template v-slot:cell(price)="row">
											<span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
											<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
											<span v-else> 
											{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span>
										</template>
										<template v-slot:cell(commission)="row">
											<span>{{$root.currency($root.tofixed(row.value, 2))}} ({{row.item.commission_rate}}%)</span>
										</template>
										<template v-slot:cell(created_at)="row">
											<span>{{$moment(row.value).format('DD-MM-YYYY HH:mm:ss')}}</span>
										</template>
										<template v-slot:cell(order_status)="row">
											<b-badge pill :variant="$root.filterorderstatus(row.value)[0].color" >{{$root.filterorderstatus(row.value)[0].label}}</b-badge>
										</template>
										<template v-slot:cell(payment_status)="row">
											<b-badge pill :variant="$root.filterpaymentstatus(row.value)[0].color" >{{$root.filterpaymentstatus(row.value)[0].label}}</b-badge>
										</template>
										<template v-slot:cell(delivery_status)="row">
											<b-badge pill :variant="$root.filterdeliverystatus(row.value)[0].color" >{{$root.filterdeliverystatus(row.value)[0].label}}</b-badge>
										</template>
										<template v-slot:cell(image)="row">
											<b-img v-bind="thumbnailProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/stock/img/'+row.item.design_id+'.png'">{{row}}</b-img>
										</template>
										<template v-slot:cell(actions)="row">
											 <b-button :href="'/seller/orderdetails/'+row.item.uuid" pill variant="primary" class="mr-1"  size="sm">View</b-button>
											<!--<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">Delete</b-button>-->
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>

				


				
			</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
	</div>
	
</template>
<script>
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";

//import orderProcess from "@/components/order-process.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		//"order-process": orderProcess,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
		
	},
	data() {
		return{
			
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            regularProps: { blank: false, width: 200, height: 200, class: 'm1' },
			url: this.$root.WEBURL+'customer-orders',
            recordUrl: this.$root.WEBAPI+'sellerapi/order-record',
			updateUrl: this.$root.WEBAPI+'sellerapi/order-update',
			updateStatusUrl: this.$root.WEBAPI+'sellerapi/order-status-update',
			updateSRUrl: this.$root.WEBAPI+'sellerapi/order-SRupdate',
			deleteUrl: this.$root.WEBAPI+'sellerapi/order-delete',
			pickupUrl: this.$root.WEBAPI+'sellerapi/getPickupaddress',
			invoiceEmailUrl: this.$root.WEBAPI+'sellerapi/invoiceEmailSend',
			businessDetailUrl: this.$root.NEWAPIURL+'profileapi/load-business',
			updateOtherSUrl: this.$root.WEBAPI+'sellerapi/order-Otherupdate',
			thumbnailLogoinvoice: { blank: false, fluidGrow: true, width: 200, height: 200,class: 'm1' },
			datefrom: '',
			dateto: '',
			order_status: '',

			picklist: [],

            records: [],
            submitdata: {
                uuid:'',
                order_status: 3,
                payment_status: 0,
                delivery_status: 0,
                shipping_data:{
                    service: '',
                    trackid: '',
                    data: '',
                    comment: '',
                    shipment_id: '',
                    awb_code: '',
                    label_url: '',                   
                    manifest_url: '',
                    pickup_token_number: '',
                },
                payment_data:{
                    txn_id: '',
                    txn_type: '',
                    txn_comment: '',
                }
            },
            cut_options: [],
            color_options: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Dyo Designs',
					active: true
				}
			],
			picklistfields:[
				{ key: 'title', label: 'Title'},
				{ key: 'sku', label: 'SKU'},
				{ key: 'qty', label: 'Qty'},
			],
			fields: [
                { key: 'id', label: 'ID'},
                { key: 'uuid', label: 'Order Id'},
                { key: 'created_at', label: 'Order Date' },
				{ key: 'total_items', label: 'Total Qty' },
                { key: 'price', label: 'Price' },
                { key: 'discount', label: 'Discount' },
                { key: 'order_status', label: 'Status' },
                { key: 'payment_status', label: 'Payment' },
                { key: 'delivery_status', label: 'Delivery' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
            ],
            itemfields: [
                { key: 'design_id', label: 'Design ID'},
                { key: 'title', label: 'Name'},
                { key: 'image_front', label: 'Front'},
                { key: 'image_back', label: 'Back'}
            ],
            orderfields: [
                { key: 'title', label: 'Name'},
                { key: 'sku', label: 'SKU', class: 'text-right'},
                { key: 'price', label: 'Price', class: 'text-center'},
				{ key: 'qty', label: 'Qty', class: 'text-center'},
				{ key: 'commission', label: 'Comm.', class: 'text-center'},
                { key: 'total_price', label: 'Total Price', class:'text-right'},
            ],
            artworkfields: [
                { key: 'label', label: 'Name'},
                { key: 'color', label: 'Color', class: 'text-right'},
            ],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
                id: 0,
                order_items: [],
                customer_data:{
                    'billing':{},
                    'shipping':{}
                },
                price:0,
                commission: 0,
            },
			
			srToken:'',
			shippingBy:'',
			selected: '',
			selectedProcessby:'shiprocket', 
			options: [
			  { text: 'Shiprocket', value: 'shiprocket' },
			  { text: 'Other', value: 'other' }
			],			 
			optionsPickup: [],
			orderItemData:[],
			pickupAddress:[],
			courierList:[],		
			courierListOptions:[],		
			opStep1:{'weight':0,'length':0,'width':0,'height':0,'ppCode':''},
			selectCourierCompanyId:'',
			sr_order_id:'112808875',
			sr_shipment_id:'112398653',
			shippingAddressSR:[],
			selectOrderElement:{
				pickupAddressObj:'',
				pickupAddressDisplay:'',
				pickup_location:'',
				pickup_pincode:'',
				delivery_postcode:'',
				courier_company_id:'',
				
				weight:'',
				length:'',
				width:'',
				height:'',
				ppCode:'',
				
				awb_code:'',
				label_url:'',
				manifest_url:'',
				pickup_token_number:'',
				shipment_id:'',
				shipment_order_id:'',
				
				
			},
			selectOrderElementState:{
				weight:null,
				length:null,
				width:null,
				height:null,
				ppCode:null,
				pickupAddressObj:null,
			},selectOrderElementErrot:{
				weight:'Weight is required!',
				length:'Length is required!',
				width:'Width is required!',
				height:'Height is required!'
			},
			shipping_dataState:{
                    service: null,
                    trackid: null,
                    data: null,
                    comment: null,
                    shipment_id: null,
                    awb_code: null,
                    label_url: null,                   
                    manifest_url: null,
                    pickup_token_number: null,
             },
			tabIndex: 0,
			tabIndexothers: 0,
			randomNumber:'',
			businessDetails:{
				business_name:'',
				business_logo:'',
				pan:'',
				gst:'',
				office_address:'',
				communication_address:'',
				brandas:'',
			},
			firstname:'',
			
			
		};
	},
	methods: {
		
		getColorName(color){
			var selectedcolor = '';
			for(var i = 0; i<this.color_options.length; i++){
				if('#'+this.color_options[i].hexcode == color){
					selectedcolor = this.color_options[i];
					break;
				}
			}
			return '<span style="vertical-align:top">'+selectedcolor.title+"</span><div style='background-color:"+color+"; width:20px; height:20px; display:inline-block; margin-left:10px;'></div>";
		},
        convertToArray(obj){
            var arr = [];
            //console.log(obj);
            for (const [key, value] of Object.entries(obj)) {
                //console.log(`${key}: ${value}`);
                console.log(key);
                var o = {};
                o.label = value.label;
                o.color = value.color;
                arr.push(o);
            }
            return arr;
        },
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			var self = this;
			//self.tabIndex= 0;
			//self.tabIndexothers= 0;
			console.log(JSON.stringify(item));
            self.selectedItem = Object.assign({}, item);
            /*self.submitdata.uuid = item.uuid;
            self.submitdata.order_status = item.order_status;
            self.submitdata.payment_status = item.payment_status;
            self.submitdata.delivery_status = item.delivery_status;
            self.submitdata.shipping_data = Object.assign({}, JSON.parse(item.shipping_data));
			if(item.payment_data!=''){
            self.submitdata.payment_data = Object.assign({}, JSON.parse(item.payment_data));
			} */
			//self.orderItemData=item;
				
			/* ********** Shipping BY SR ********** */
				//var sRshippingdata = item.shipping_data_sr;
				//console.log(sRshippingdata);
				//if(sRshippingdata!=''){
						//self.tabIndex=2;
						/* var sRshippingdataObj =  JSON.parse(sRshippingdata);
						var payload =sRshippingdataObj.payload;
					  self.selectOrderElement.awb_code = payload.awb_code;
					  self.selectOrderElement.label_url = payload.label_url;
					  self.selectOrderElement.manifest_url = payload.manifest_url;
					  self.selectOrderElement.pickup_token_number = payload.pickup_token_number;
					  self.selectOrderElement.shipment_id = payload.shipment_id;
					  self.selectOrderElement.shipment_order_id = payload.order_id; */
					  
					  
					  /* self.selectedProcessby= 'shiprocket';
					  self.shippingBy = 'shiprocket';*/
				
				
				//}else{
					/* For Other Shipping Option*/
					/* self.tabIndexothers=1;
					self.selectedProcessby= 'other';
					self.shippingBy = 'other'; */
				//}
			
			
			/* ******************* */
			
			
				//console.log('Ram Ji');
			/* --------------SR Token --------------- */
			
			/* if(self.srToken==''){
				var shipRocketUrl='https://apiv2.shiprocket.in/v1/external/auth/login';
				self.axios.post(shipRocketUrl, {
					email: "mahato@alluraa.com",
					password: "4ChmH5nKGnPigjpkV%6H43ZujRFRmPcX"
				})
				.then(function (response) {
					//console.log(objResp);
					var objResp = response.data;
					//console.log('MyToken'+objResp.token);
					self.srToken = objResp.token;
					
					//console.log('MyToken'+this.srToken);

					

				})
				.catch(function (error) {
					alert(error);
				});
			}*/
			/* --------------------------------- */
			console.log(button);
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		resetSelectedItem(){
			//var self = this;
			//self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
                accesskey: self.$root.customer_info.access_key
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    var _records = response.data.result.orders;
					self.records = _records;
                    //console.log(self.share_data);
					self.loading = false;
					self.totalRows = _records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			
			
			
			
			
			
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
        },	
		
		
		
		
	}
}
</script>
<style  lang="scss">
.disabledTab{
      pointer-events: none;
  }
  
  .ivoiceTAle{
		.table td,.table th{
			border-top: 0px solid #dee2e6 !important;
		}
		.invoiceTitle{
			text-align:center !important;
			border-top: 1px solid #dee2e6 !important;
			border-bottom: 1px solid #dee2e6 !important;
		}
		.tblbr{
			border-right: 1px solid #dee2e6 !important;
		}
	}
</style>